module.exports = __webpack_public_path__ + "img/content-image-1.d0fda51a.png";